import React from 'react';
import { Link } from 'react-router';
import ProcedenciaLead from './ProcedenciaLead';

/**
 * Los leads por procedencia («para tener un buen recuento de qué trae cada
 * cosa»). Lo cuenta el servidor (procedencia_lead.recuento, con las mismas
 * reglas que la lista de Leads) y aquí se pinta: primero las campañas de cada
 * tratamiento, cada una con su número, y luego las demás vías; cada
 * procedencia lleva a la lista de Leads filtrada por ella.
 *
 *  · Recibidos: los que no están descartados (los ya citados sí).
 *  · Contactados y ya citados: de los recibidos.
 *  · Descartados: aparte; no cuentan en recibidos.
 *
 * Lo usa Indicadores.
 */
const COLUMNAS = [
  { k: 'recibidos', nombre: 'Recibidos' },
  { k: 'contactados', nombre: 'Contactados' },
  { k: 'citados', nombre: 'Ya citados' },
  { k: 'descartados', nombre: 'Descartados' },
];

export default function RecuentoProcedencia({
  filas, totales, testid = 'recuento-procedencia',
}) {
  const columnas = COLUMNAS;
  const campanas = (filas || []).filter((f) => f.grupo === 'campana');
  const vias = (filas || []).filter((f) => f.grupo !== 'campana');

  const fila = (f) => {
    const vacia = !f.recibidos && !f.descartados;
    return (
      <tr key={f.clave} className={`border-b last:border-0 ${vacia ? 'text-muted-foreground' : ''}`}
        data-testid={`${testid}-${f.clave}`}>
        <td className="py-1.5 pr-3 pl-3">
          <Link to={`/leads?procedencia=${encodeURIComponent(f.clave)}`} className="hover:opacity-80"
            title="Ver estos contactos en Leads">
            <ProcedenciaLead procedencia={f} />
          </Link>
        </td>
        {columnas.map((c) => (
          <td key={c.k} className={`py-1.5 pr-3 text-right tabular-nums ${c.k === 'recibidos' ? 'font-medium' : ''}`}
            data-testid={`${testid}-${f.clave}-${c.k}`}>
            {f[c.k] ?? 0}
          </td>
        ))}
      </tr>
    );
  };

  const subtotal = (nombre, t, clave) => (
    <tr className="bg-muted/40 text-xs font-semibold" data-testid={`${testid}-${clave}`}>
      <td className="py-1.5 pr-3">{nombre}</td>
      {columnas.map((c) => (
        <td key={c.k} className="py-1.5 pr-3 text-right tabular-nums" data-testid={`${testid}-${clave}-${c.k}`}>
          {t?.[c.k] ?? 0}
        </td>
      ))}
    </tr>
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full max-w-3xl text-sm" data-testid={testid}>
        <thead>
          <tr className="text-left text-xs text-muted-foreground border-b">
            <th className="py-2 pr-3">Procedencia</th>
            {columnas.map((c) => <th key={c.k} className="py-2 pr-3 text-right">{c.nombre}</th>)}
          </tr>
        </thead>
        <tbody>
          {subtotal('Campañas', totales?.campanas, 'campanas')}
          {campanas.map(fila)}
          {vias.length ? subtotal('Otras vías', totales?.vias, 'vias') : null}
          {vias.map(fila)}
          {subtotal('Total', totales?.todos, 'total')}
        </tbody>
      </table>
    </div>
  );
}
